module.exports = __webpack_public_path__ + "json/market16-0.json?f448e59ac9a0cd11831fb5ae8602f367";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market16-0.json
// module id = 1259
// module chunks = 3